export default "__VITE_ASSET__TSxOfKSnEFu5SrHkQZDEEA__"